import { searchTypeFilterEnabled$ } from "./search-page-type-filter.component";
import { allSearchTypeFiltersDisabled$ } from "./type-filters-panel.component";

const states = {
    visible: 0,
    hidden: 1,
};

export default class HelperTextComponent {
    constructor(node) {
        this.node = node;
        this.initialize();
        this.subscribeOnTypeFiltersChanges();
    }

    initialize() {
        this.currentState = states.visible;
        this.setActiveVisualState();
    }

    subscribeOnTypeFiltersChanges() {
        searchTypeFilterEnabled$.subscribe(() => {
            if (this.currentState === states.visible) {
                this.setPassiveVisualState();
            }
            this.currentState = states.hidden;
        });

        allSearchTypeFiltersDisabled$.subscribe(() => {
            if (this.currentState === states.hidden) {
                this.setActiveVisualState();
            }
            this.currentState = states.visible;
        });
    }

    setActiveVisualState() {
        this.node.addClass("active");
    }

    setPassiveVisualState() {
        this.node.removeClass("active");
    }
}
